import resolveColorFunction from '../../resolvers/ColorResolver';
export default function resolveColor(theme, screenWidth, colorSupport) {
    var result = {};
    if (colorSupport.color !== undefined) {
        result.color = resolveColorFunction(theme, screenWidth, colorSupport.color);
    }
    return result;
}
//# sourceMappingURL=ColorResolver.js.map